import { useEffect, useRef } from 'react'

import { trackEvent } from '~/shared/lib/analytics'

import { DOCUMENT_TAB_HIDDEN, DOCUMENT_TAB_VISIBLE } from '../config'
import { useStepSession } from './step-session-context'

export function useTabVisibility() {
  const { step, documentKey, hasDownloaded, addIdleTime } = useStepSession()
  const hiddenAtRef = useRef<number | null>(null)

  useEffect(() => {
    const handler = () => {
      if (document.visibilityState === 'hidden') {
        hiddenAtRef.current = Date.now()
        trackEvent(DOCUMENT_TAB_HIDDEN, {
          step,
          document_key: documentKey,
          has_downloaded: hasDownloaded,
        })
      } else {
        const hiddenAt = hiddenAtRef.current
        if (hiddenAt !== null) {
          const durationSec = (Date.now() - hiddenAt) / 1000
          addIdleTime(durationSec)
          hiddenAtRef.current = null
        }
        trackEvent(DOCUMENT_TAB_VISIBLE, {
          step,
          document_key: documentKey,
          has_downloaded: hasDownloaded,
        })
      }
    }

    document.addEventListener('visibilitychange', handler)
    return () => document.removeEventListener('visibilitychange', handler)
  }, [step, documentKey, hasDownloaded, addIdleTime])
}
